import * as React from 'react';

import { AllowedViewers } from '@/components/AllowedViewers';
import {
  ReadOnly,
  ReadOnlyLabel,
  ReadOnlyNoValue,
  ReadOnlyValue,
} from '@/components/ReadOnly';
import { AttributeFragment } from '@/modules/attributes/graphql-types/AttributeFragment';

export const Attribute: React.FC<{
  attribute: AttributeFragment;
  isViewingOwnProfile: boolean;
}> = ({ attribute, isViewingOwnProfile }) => {
  return (
    <ReadOnly key={attribute._id}>
      <ReadOnlyLabel>{attribute.label}</ReadOnlyLabel>

      {attribute.__typename === 'MultiSelectAttribute' &&
      attribute.multiSelectValue.length ? (
        <ReadOnlyValue>
          {attribute.multiSelectValue
            .map(
              (optionId) =>
                attribute.options.find((option) => option.id === optionId)
                  ?.label
            )
            .join(', ')}
        </ReadOnlyValue>
      ) : attribute.__typename === 'SingleSelectAttribute' &&
        attribute.singleSelectValue ? (
        <ReadOnlyValue>
          {
            attribute.options.find(
              (option) => option.id === attribute.singleSelectValue
            )?.label
          }
        </ReadOnlyValue>
      ) : attribute.__typename === 'FreeTextAttribute' &&
        attribute.freeTextValue ? (
        <ReadOnlyValue>{attribute.freeTextValue}</ReadOnlyValue>
      ) : (
        <ReadOnlyNoValue>
          No {attribute.label.toLowerCase()} provided
        </ReadOnlyNoValue>
      )}

      {isViewingOwnProfile && (
        <AllowedViewers
          allowedViewers={attribute.allowedViewers}
          ownerKind={attribute.ownerKind}
          isViewingOwnProfile={isViewingOwnProfile}
          allowedEditors={attribute.allowedEditors}
          canCurrentUserEditValue={attribute.canCurrentUserEditValue}
        />
      )}
    </ReadOnly>
  );
};
